import { Col, Divider, Flex, Form, Input, Row, Select } from 'antd'
import React from 'react'
import Dental from '../Dental/Dental'
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getDiagnosis, getMaterials, getSymptoms } from '../../../network/encounters';
import { useQuery } from '@tanstack/react-query';
import { getComplaint } from '../../../network/complaint';

const TeethSelection = ({t,form,setDental,dental}) => {
  console.log(dental, 'dental ffwwwwwwwwwwwww' );
    const handleToothClick = (tooth) => {
        setDental((prev) =>
          prev.includes(tooth) ? prev.filter((t) => t !== tooth) : [...prev, tooth]
        );
      };
      const { data: materials, isLoading: materialsLoading } = useQuery({
        queryKey: [queryKeys.getMaterialsList],
        queryFn: () => getMaterials(),
        keepPreviousData: true,
      });
      const { data: diagnosis } = useQuery({
        queryKey: [queryKeys.getDiagnosis],
        queryFn: () => getDiagnosis(),
        keepPreviousData: true,
      });
      // const { data: symptoms } = useQuery({
      //   queryKey: [queryKeys.getSymptoms],
      //   queryFn: () => getSymptoms(),
      //   keepPreviousData: true,
      // });
      const { data: complaint } = useQuery({
        queryKey: [queryKeys.getComplaint],
        queryFn: () => getComplaint(),
        keepPreviousData: true,
      });
    
  return (
    <>
                <Row>
              <Divider orientation="left">Teeth Selection</Divider>
              <Flex
                gap={10}
                align="start"
                style={{ width: '100%' }}
                justify="center"
                className='teeth-selection'
                // wrap
              >
                {/* <Col span={24}> */}
                <Form.Item
                  name="custom_selected_teeth"
                  // rules={[{ required: true, message: t.requiredNotes }]}
                >
                  <Dental onToothClick={handleToothClick} teeth={dental} />
                </Form.Item>
                {/* </Col> */}
                <Row style={{ width: '100%', marginBottom: '10px' }}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name="custom_root"
                      label={t.Root}
                      style={{ width: '100%', marginBottom: '0px' }}
                      // rules={[{ required: true, message: t.requiredNotes }]}
                    >
                      <Select style={{ width: '100%' }} placeholder={t.Root}>
                        <Select.Option value="Missing">
                          {' '}
                          {t.Missing}{' '}
                        </Select.Option>
                        <Select.Option value="Ext"> {t.Ext} </Select.Option>
                        <Select.Option value="OVR"> {t.OVR} </Select.Option>
                        <Select.Option value="NYE"> {t.NYE} </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name="custom_crown"
                      label={t.Crown}
                      style={{ width: '100%', marginBottom: '0px' }}
                      mode="multiple"
                      // rules={[{ required: true, message: t.requiredNotes }]}
                    >
                      <Select style={{ width: '100%' }} placeholder={t.Crown}>
                        <Select.Option value="D">D</Select.Option>
                        <Select.Option value="B">B</Select.Option>
                        <Select.Option value="O">O</Select.Option>
                        <Select.Option value="L">L</Select.Option>
                        <Select.Option value="M">M</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name="custom_tilts"
                      label={t.Tilts}
                      style={{ width: '100%', marginBottom: '0px' }}
                      >
                      <Select style={{ width: '100%' }} placeholder={t.Tilts}>
                        <Select.Option value="Forward">Forward</Select.Option>
                        <Select.Option value="Backward">Backward</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name="symptoms"
                      label={t.complaints}
                       >
                      <Select
                        placeholder={t.complaints}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLocaleLowerCase()
                            .includes(input)
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        mode="multiple"
                        options={complaint?.data?.map((complaint) => ({
                          value: complaint.name,
                          label: complaint.name,
                        }))}
                        // options={symptoms?.message?.symptoms?.map(
                        //   (country) => ({
                        //     value: country.name,
                        //     label: country.complaints,
                        //   })
                        // )}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name="diagnosis"
                      label={t.diagnosis}
                      // label={t.name}
                      // rules={[{ required: true, message: t.requiredSymptoms }]}
                    >
                      <Select
                        placeholder={t.diagnosis}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLocaleLowerCase()
                            .includes(input)
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        mode="multiple"
                        options={diagnosis?.message?.diagnosis?.map(
                          (country) => ({
                            value: country.name,
                            label: country.diagnosis,
                          })
                        )}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name="custom_materials"
                      label={t.Materials}
                      // label={t.name}
                      // rules={[{ required: true, message: t.requiredSymptoms }]}
                    >
                      <Select
                        placeholder={t.Materials}
                        showSearch
                        isLoading={materialsLoading}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? '')
                            .toLocaleLowerCase()
                            .includes(input)
                        }
                        filterSort={(optionA, optionB) =>
                          (optionA?.label ?? '')
                            .toLowerCase()
                            .localeCompare((optionB?.label ?? '').toLowerCase())
                        }
                        mode="multiple"
                        options={materials?.message?.materials?.map(
                          (country) => ({
                            value: country.name,
                            label: country.name,
                          })
                        )}
                      />
                    </Form.Item>
                  </Col>
                  {/* <Col xs={24} sm={24} md={24} lg={24}>
                    <Form.Item
                      name="encounter_comment"
                      label={t.ReviewDetails}
                      // label={t.name}
                      // rules={[{ required: true, message: t.requiredNotes }]}
                    >
                      <Input.TextArea
                        placeholder={t.ReviewDetails}
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        />
                    </Form.Item>
                  </Col> */}
                </Row>
              </Flex>
            </Row>
    </>
  )
}

export default TeethSelection